import React from "react";
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import green from '@material-ui/core/colors/green';
import red from '@material-ui/core/colors/red';
import { Divider, Paper } from "@material-ui/core";
import TextField from '@material-ui/core/TextField';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';

const theme = createMuiTheme({
    overrides: {
        /*MuiInputBase: {
            root: {
                marginTop: '20px',
            },
            input: {
                paddingTop: '10px',
            }
        },
        MuiFormLabel: {
            root: {
                width: '170px',
            },
        },        
        MuiFormControl: {
            root: {
                marginTop: '16px',
                marginBottom: '8px',
            }
        }*/
        MuiFormControlLabel: {
            root: {
                margin: '0px',
                marginRight: '0px',
            },
            label: {
                margin: '0px',
            },
        },
        MuiIconButton: {
            root: {
                margin: '0px',
                marginRight: '0px',
            },
        }
    }
});

const styles = theme => ({
    root: {
        flexGrow: 1,
        overflow: 'hidden',
    },
    paper: {
        padding: theme.spacing.unit,
        margin: theme.spacing.unit,
    },
    card: {
      minWidth: 275,
    },
    bullet: {
      display: 'inline-block',
      margin: '0 2px',
      transform: 'scale(0.8)',
    },
    title: {
      fontSize: 18,
      fontWeight: 'bold',
    },
    pos: {
      marginBottom: 12,
    },
    group: {
      margin: `${theme.spacing.unit}px 0`,
    },
    formControl: {
        margin: theme.spacing.unit,
    },
    formLabel: {
        textAlign: 'left',
    },
    formInput: {
        padding: 0,
    },
    formExtractions: {
        margin: 0,
        padding: 0,
    },
    greenradio: {
        color: green[600],
        '&$checked': {
            color: green[500],
        },
    },
    redradio: {
        color: red[600],
        '&$checked': {
            color: red[500],
        },
    },
    cbExtroot: {
        //padding: '0px',
        //margin: '0px',
    },
    divider: {
        margin: 16,
    }
});

class ClaimENStep4 extends React.Component {
    state = {
        fp17data: this.props.fp17data,
        pdata: this.props.pdata,
        formType: false,
    };

    componentDidMount() {
        //
    }

    handleChange = name => event => {
        //this.setState({ [name]: event.target.value });
        let datatmp = this.state.fp17data;
        datatmp[name] = event.target.value;
        this.setState({fp17data: datatmp});   
    };

    handleCheckChange = name => event => {
        //this.setState({ [name]: event.target.value });
        let value = undefined;

        if (event.target.checked === true && event.target.value)
            value = event.target.value;
        else if (event.target.checked === true)
            value = event.target.checked;
        else
            value = undefined;

        let datatmp = this.state.fp17data; 
        datatmp[name] = value;
        this.setState({fp17data: datatmp}); 
    };

    handleTypeChange = name => event => {
        this.setState({ [name]: event.target.checked });

        let stage = 'A';
        if (event.target.checked === true)
            stage = 'C';

        let datatmp = this.state.fp17data; 
        datatmp.orthoStage = stage;
        this.setState({fp17data: datatmp});     

    };    

    handleExtractionChange = (name, selected) => {

        let datatmp = this.state.fp17data;
        let checkedArray = datatmp.ods9408;

        let merged = {...checkedArray, ...selected}

        datatmp.ods9408 = merged;

        this.setState({fp17data: datatmp});
  
    }

    render() {
        const { classes } = this.props;

        return (
        <MuiThemeProvider theme={theme}>
        <div className={classes.root}>
            <Paper className={classes.paper}>
                <Typography className={classes.title} color="textSecondary" gutterBottom>
                Form Type
                </Typography>
                Assessment & Start
                <Switch
                    checked={this.state.formType}
                    onChange={this.handleTypeChange('formType')}
                    value="A"
                    color="default"
                />
                Completion
            </Paper>
            { this.state.formType === false ?
            <Paper className={classes.paper}>
                <Typography className={classes.title} color="textSecondary" gutterBottom>
                Part 5 Orthodontic Assessment and Treatment Start
                </Typography>
                <Grid container spacing={1}>
                    <Grid item xs={6} sm={4} md={2}>
                        <FormControl className={classes.formControl} fullWidth={true}>
                            <FormControlLabel
                                value="y"
                                id="ods9012"
                                label="Asessment & review"
                                control={<Checkbox checked={this.state.fp17data.ods9012 === 'y'}/>}
                                onChange={this.handleCheckChange('ods9012')}
                            />
                        </FormControl>   
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                        <FormControl className={classes.formControl} fullWidth={true}>
                            <FormControlLabel
                                value="y"
                                id="ods9013"
                                label="Asess & refuse treatment"
                                control={<Checkbox checked={this.state.fp17data.ods9013 === 'y'}/>}
                                onChange={this.handleCheckChange('ods9013')}
                            />
                        </FormControl>   
                    </Grid>                        
                    <Grid item xs={6} sm={4} md={2}>
                        <FormControl className={classes.formControl} fullWidth={true}>
                            <FormControlLabel
                                value="y"
                                id="ods9014"
                                label="Assess & appliance fitted"
                                control={<Checkbox checked={this.state.fp17data.ods9014 === 'y'}/>}
                                onChange={this.handleCheckChange('ods9014')}
                            />
                        </FormControl>  
                    </Grid> 
                    <Grid item xs={6} sm={4} md={2}>
                        <FormControl className={classes.formControl} fullWidth={true}>
                            <FormControlLabel
                                value="y"
                                id="comapp"
                                label="Commisioner Approval"
                                control={<Checkbox checked={this.state.fp17data.comapp === 'y'}/>}
                                onChange={this.handleCheckChange('comapp')}
                            />
                        </FormControl>  
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                        <TextField
                            id="ods9015"
                            label="IOTN"
                            value={this.state.fp17data.ods9015}
                            type="number"
                            inputProps={{ min: "0", max: "5", step: "1" }}
                            className={classes.textField}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            margin="normal"
                            fullWidth="true"
                            helperText="Enter no."
                            onChange={this.handleChange('ods9015')}
                        />                                                                                          
                    </Grid> 
                    <Grid item xs={6} sm={4} md={2}>
                        <TextField
                            id="ods9165"
                            label="Aesthetic component"
                            value={this.state.fp17data.ods9165}
                            type="number"
                            inputProps={{ min: "0", max: "10", step: "1" }}
                            className={classes.textField}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            margin="normal"
                            fullWidth="true"
                            helperText="Enter no."
                            onChange={this.handleChange('ods9165')}
                        />                                                                                          
                    </Grid>  
                    <Grid item xs={6} sm={4} md={2}>
                        <FormControl className={classes.formControl} fullWidth={true}>
                            <FormControlLabel
                                value="y"
                                id="noiotn"
                                label="IOTN not applicable"
                                control={<Checkbox checked={this.state.fp17data.noiotn === 'y'}/>}
                                onChange={this.handleCheckChange('noiotn')}
                            />
                        </FormControl>   
                    </Grid> 

                    <Grid item xs={12} sm={4} md={3}>
                        <FormControl className={classes.formControl} fullWidth={false}>
                        <TextField
                            id="claim-datref"
                            label="Date of Referral"
                            type="date"
                            className={classes.textField} 
                            value={this.state.fp17data.datref}
                            onChange={this.handleChange('datref')}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            />
                        </FormControl>                     
                    </Grid>   
                    <Grid item xs={12} sm={4} md={3}>
                        <FormControl className={classes.formControl} fullWidth={false}>
                        <TextField
                            id="claim-datcc"
                            label="Date of Assessment"
                            type="date"
                            className={classes.textField} 
                            value={this.state.fp17data.datcc}
                            onChange={this.handleChange('datcc')}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            />
                        </FormControl>                     
                    </Grid>   
                    <Grid item xs={12} sm={4} md={3}>
                        <FormControl className={classes.formControl} fullWidth={false}>
                        <TextField
                            id="claim-datapp"
                            label="Date Appliance Fitted"
                            type="date"
                            className={classes.textField} 
                            value={this.state.fp17data.datapp}
                            onChange={this.handleChange('datapp')}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            />
                        </FormControl>                     
                    </Grid>                                                               
                </Grid>                    
            </Paper>
            : null }
            { this.state.formType === true ?
            <Paper className={classes.paper}>
                <Typography className={classes.title} color="textSecondary" gutterBottom>
                Part 6 Orthodontic Completion
                </Typography>
                <Grid container spacing={1}>
                    <Grid item xs={6} sm={4} md={2}>
                        <FormControl className={classes.formControl} fullWidth={true}>
                            <FormControlLabel
                                value="y"
                                id="ods9409"
                                label="Treatment abandoned - patient failed to return"
                                control={<Checkbox checked={this.state.fp17data.ods9409 === 'y'}/>}
                                onChange={this.handleCheckChange('ods9409')}
                            />
                        </FormControl>   
                    </Grid>
                    <Grid item xs={6} sm={4} md={2}>
                        <FormControl className={classes.formControl} fullWidth={true}>
                            <FormControlLabel
                                value="y"
                                id="ods9410"
                                label="Treatment abandoned - patient requested"
                                control={<Checkbox checked={this.state.fp17data.ods9410 === 'y'}/>}
                                onChange={this.handleCheckChange('ods9410')}
                            />
                        </FormControl>   
                    </Grid>                        
                    <Grid item xs={6} sm={4} md={2}>
                        <FormControl className={classes.formControl} fullWidth={true}>
                            <FormControlLabel
                                value="2"
                                id="ods9161"
                                label="Treatment discontinued"
                                control={<Checkbox checked={this.state.fp17data.ods9161 === '2'}/>}
                                onChange={this.handleCheckChange('ods9161')}
                            />
                        </FormControl>  
                    </Grid> 
                    <Grid item xs={6} sm={4} md={2}>
                        <FormControl className={classes.formControl} fullWidth={true}>
                            <FormControlLabel
                                value="3"
                                id="ods9161"
                                label="Treatment completed"
                                control={<Checkbox checked={this.state.fp17data.ods9161 === '3'}/>}
                                onChange={this.handleCheckChange('ods9161')}
                            />
                        </FormControl>  
                    </Grid> 
                    <Grid item xs={6} sm={4} md={2}>
                        <FormControl className={classes.formControl} fullWidth={true}>
                            <FormControlLabel
                                value="3"
                                id="ods9411"
                                label="PAR scores calculated"
                                control={<Checkbox checked={this.state.fp17data.ods9411 === '3'}/>}
                                onChange={this.handleCheckChange('ods9411')}
                            />
                        </FormControl>  
                    </Grid> 
                    <Grid item xs={6} sm={4} md={2}>
                        <TextField
                            id="ods9015"
                            label="IOTN"
                            value={this.state.fp17data.ods9015}
                            type="number"
                            inputProps={{ min: "0", max: "5", step: "1" }}
                            className={classes.textField}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            margin="normal"
                            fullWidth="true"
                            helperText="Enter no."
                            onChange={this.handleChange('ods9015')}
                        />                                                                                          
                    </Grid> 
                    <Grid item xs={6} sm={4} md={2}>
                        <TextField
                            id="ods9165"
                            label="Aesthetic component"
                            value={this.state.fp17data.ods9165}
                            type="number"
                            inputProps={{ min: "0", max: "10", step: "1" }}
                            className={classes.textField}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            margin="normal"
                            fullWidth="true"
                            helperText="Enter no."
                            onChange={this.handleChange('ods9165')}
                        />                                                                                          
                    </Grid>  
                    <Grid item xs={6} sm={4} md={2}>
                        <FormControl className={classes.formControl} fullWidth={true}>
                            <FormControlLabel
                                value="y"
                                id="noiotn"
                                label="IOTN not applicable"
                                control={<Checkbox checked={this.state.fp17data.noiotn === 'y'}/>}
                                onChange={this.handleCheckChange('noiotn')}
                            />
                        </FormControl>   
                    </Grid> 

                    <Grid item xs={12} sm={4} md={3}>
                        <FormControl className={classes.formControl} fullWidth={false}>
                        <TextField
                            id="claim-datcp"
                            label="Date of completion or last visit"
                            type="date"
                            className={classes.textField} 
                            value={this.state.fp17data.datcp}
                            onChange={this.handleChange('datcp')}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            />
                        </FormControl>                     
                    </Grid> 

                    <Grid item xs={6} sm={4} md={2}>
                        <FormControl className={classes.formControl} fullWidth={true}>
                            <FormControlLabel
                                value="y"
                                id="ods9159"
                                label="Repair to appliance fitted by another dentist"
                                control={<Checkbox checked={this.state.fp17data.ods9159 === 'y'}/>}
                                onChange={this.handleCheckChange('ods9159')}
                            />
                        </FormControl>   
                    </Grid>  
                    <Grid item xs={6} sm={4} md={2}>
                        <FormControl className={classes.formControl} fullWidth={true}>
                            <FormControlLabel
                                value="y"
                                id="ods9167"
                                label="Regulation 11 replacement appliance"
                                control={<Checkbox checked={this.state.fp17data.ods9167 === 'y'}/>}
                                onChange={this.handleCheckChange('ods9167')}
                            />
                        </FormControl>   
                    </Grid>

                    <Grid item xs={12} sm={12} md={3}>
                        PAR scores calculated:&nbsp;
                        No
                        <Switch
                            checked={this.state.fp17data.orthoPAR}
                            onChange={this.handleCheckChange('orthoPAR')}
                            color="primary"
                        />
                        Yes
                    </Grid> 

                    { this.state.fp17data.orthoPAR === true ?
                    <>
                    <Grid item xs={6} sm={6} md={2}>
                        <TextField
                            id="orthoPrePAR"
                            label="Pre-treatment PAR"
                            value={this.state.fp17data.orthoPrePAR}
                            type="number"
                            inputProps={{ min: "0", max: "99", step: "1" }}
                            className={classes.textField}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            margin="normal"
                            fullWidth="true"
                            helperText="Enter no."
                            onChange={this.handleChange('orthoPrePAR')}
                        />                                                                                          
                    </Grid>
                    <Grid item xs={6} sm={6} md={2}>
                        <TextField
                            id="orthoPostPAR"
                            label="Post-treatment PAR"
                            value={this.state.fp17data.orthoPostPAR}
                            type="number"
                            inputProps={{ min: "0", max: "99", step: "1" }}
                            className={classes.textField}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            margin="normal"
                            fullWidth="true"
                            helperText="Enter no."
                            onChange={this.handleChange('orthoPostPAR')}
                        />                                                                                          
                    </Grid> 
                    </>
                    : null }                      
                                                                                   
                </Grid>                    
            </Paper>
            : null }
        </div>
        </MuiThemeProvider>
        );
    }
}

ClaimENStep4.propTypes = {
    classes: PropTypes.object.isRequired,
  };
  
  export default withStyles(styles)(ClaimENStep4);